











import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class QuotaTimeSelect extends Vue {
  selectedQuotaTime: number;

  @Prop({ required: true }) value: number | null;
 
  @Watch('value', { immediate: true }) onValueChanged() {
    if (this.value === null || this.value === undefined) {
      return this.selectQuotaTime(0);
    }
    this.selectedQuotaTime = this.value;
  }

  get quotaTimes() {
    return [
      { text: this.$i18n.translate("transportationPermission.quotaTimes.month", "A Month"), value: 0 },
      { text: this.$i18n.translate( "transportationPermission.quotaTimes.day", "A Day"), value: 1 },
      { text: this.$i18n.translate( "transportationPermission.quotaTimes.week", "A Week" ), value: 2 },
      { text: this.$i18n.translate( "transportationPermission.quotaTimes.year", "A Year" ), value: 3 },
      { text: this.$i18n.translate( "transportationPermission.quotaTimes.fourMonths", "Four months" ), value: 4 },
      { text: this.$i18n.translate( "transportationPermission.quotaTimes.threeMonths", "Three months" ), value: 5 },
    ];
  }

  selectQuotaTime(selectedQuotaTime: number) {
    this.selectedQuotaTime = selectedQuotaTime;
    this.$emit('input', this.selectedQuotaTime);
  }

}
